import ImageUploader from './ImageUploader.vue';

export default ImageUploader;
